import "../reportDashboard.scss";

// Circular "i" badge + content — draft-status counts and informational
// disclosures (e.g. "credentials aren't date-filtered") share this shell.
const InfoBanner = ({ children, tone = "accent" }) => (
  <div className={`rdNotice rdNotice--${tone} rdNotice--info`}>
    <span className="rdNotice__icon">i</span>
    <span>{children}</span>
  </div>
);

export default InfoBanner;
